// extracted by mini-css-extract-plugin
module.exports = {"settingSectionCard":"_3-LFJ","title":"_2ndzj","subTitle":"_3fly6"};